import { MouseEventHandler } from 'react';
import { Button, Col, ProgressBar, Row } from 'react-bootstrap';
import { IndoorStopSelect } from './IndoorStopSelect';
import { StopData } from './StopTravelBody';

interface Props {
    currentStop? : StopData | null | undefined;
    onSelect : (id : string) => void;       //Callback to handle the selection of a mission plan.
    onRun : MouseEventHandler;              //Callback to run to run the mission plan.
    onRunStop : MouseEventHandler
    selectedValue? : string;
    running : boolean;
    safe: boolean;
    home:boolean;
    progress?: number;
    robotState?: string;
}

//@ts-ignore
export const IndoorStopTravelControlBanner = ({currentStop, onSelect, onRun, onRunStop, selectedValue, running,safe, home,progress,robotState } : Props) => {
    return (
        <div className='mission-planning-banner p-3 mb-4 bg-white rounded' >
            <Row>
            <span className='text-dark h5'>Stop Select</span>
                <Col sm={5}>
                    <span className='text-dark h6 justify-content-center align-items-center'>Selected Stop</span>
                    <IndoorStopSelect onSelect={onSelect} selectedValue={selectedValue}/>
                </Col>
            </Row>
            { running && <div className='mission-info mb-3 ps-3 pe-3'>
                <ProgressBar animated now={progress??0} variant="success" id="mission-progress" className='mb-3'/>
            </div>}
            <div className='d-flex'>
                <Button variant="primary" onClick={onRun} disabled={robotState !== "READY" || running || home} className="flex-fill me-2">
                    Go Home
                </Button>
                <Button variant="primary" onClick={onRunStop} disabled={robotState !== "READY" || running || selectedValue === ''} className="flex-fill me-2">
                    Go to Stop
                </Button>
            </div>
        </div>
    );
}